// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2017 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

// Import first party modules

import './casestudies.scss';

const MODULE_NAME = 'casestudies';
angular

    .module(MODULE_NAME, [
    ])

    .directive('appCasestudies', () => {
      return {
        restrict: 'E',
        scope: true,
        template: require('./casestudies.html'),
        link: ($scope, element, attrs) => {},
      };
    })

    .controller('CasestudiesCtrl', function() {
    // ---------------------------------------------------------------------- //
    // Methods

      /**
     * onInit
     */
      function onInit() {
      }

      // ---------------------------------------------------------------------- //
      // Private

      // ---------------------------------------------------------------------- //
      // Public
      const ctrl = this;
      ctrl.list = [
        {
          id: 'getty-events',
          title: 'GETTY IMAGES',
          subtitle: 'EVENT PLATFORM',
          icon: 'getty',
        },
        {
          id: 'fabricius',
          title: 'FABRICIUS',
          subtitle: 'BRINGING MACHINE LEARNING TO THE MASSES',
          icon: 'google',
        },
        {
          id: 'hieroglyphics-initiative',
          title: 'THE HIEROGLYPHICS INITIATIVE',
          subtitle: 'MACHINE LEARNING RESEARCH PROJECT',
          icon: 'ubisoft',
        },
        {
          id: 'armani',
          title: 'ARMANI @ SXSW',
          subtitle: '360 VIDEO INSTALLATION / CHATBOT',
          icon: 'armani',
        },
        {
          id: 'gic',
          title: 'GOOGLE.ORG IMPACT CHALLENGE',
          subtitle: 'CONTEST PLATFORM',
          icon: 'google',
        },
        {
          id: 'mercedes-4matic',
          title: 'MERCEDES 4MATIC',
          subtitle: 'INTERACTIVE STORY',
          icon: 'mercedes',
        },
        {
          id: 'imperial',
          title: 'IMPERIAL COLLEGE BUSINESS SCHOOL',
          subtitle: 'INTEGRATED STUDENT PORTAL',
          icon: 'imperial',
        },
        {
          id: 'the-order',
          title: 'THE ORDER: 1886',
          subtitle: 'GAME MARKETING EXPERIENCE',
          icon: 'playstation',
        },
        {
          id: 'play-with-oreo',
          title: 'PLAY WITH OREO',
          subtitle: 'SOCIAL PLATFORM',
          icon: 'oreo',
        },
      ];

      // ---------------------------------------------------------------------- //
      // Watches/events

      // ---------------------------------------------------------------------- //
      onInit();
    });

export default MODULE_NAME;
